export const getStyles = (selected, token) => ({
  card: {
    position: "relative",
    border: `1px solid ${selected ? token.colorPrimary : token.colorBorder}`
  },
  cardBody: {
    paddingRight: token.paddingMD,
    paddingLeft: 0,
    paddingTop: 0,
    paddingBottom: 0
  },
  imageContainer: {
    width: 80,
    height: 80,
    borderRadius: `${token.borderRadiusLG}px 0 0 ${token.borderRadiusLG}px`,
    overflow: "hidden",
    backgroundColor: token.colorFillTertiary
  },
  image: {
    width: "100%",
    height: "100%",
    objectFit: "cover"
  },
  defaultImage: {
    width: "100%",
    height: "100%",
    objectFit: "contain",
    padding: token.padding,
    mixBlendMode: "darken",
    filter: "grayscale(1)",
    opacity: 0.5
  },
  editButton: {
    width: 30,
    height: 30,
    border: `1px solid ${token.colorBorder}`,
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
    transition: `all ${token.motionDurationMid}`,
    "&:hover": {
      borderColor: token.colorPrimary,
      ".anticon": {
        color: token.colorPrimary
      }
    }
  },
  checkbox: {
    width: 24,
    height: 24,
    border: `2px solid ${selected ? token.colorPrimary : token.colorBorder}`,
    borderRadius: token.borderRadiusSM,
    backgroundColor: selected ? token.colorPrimary : "transparent",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    transition: `all ${token.motionDurationMid}`
  }
})
